import { render } from "./ContactItem.vue?vue&type=template&id=0dda078c&scoped=true"
import script from "./ContactItem.vue?vue&type=script&lang=js"
export * from "./ContactItem.vue?vue&type=script&lang=js"

import "./ContactItem.vue?vue&type=style&index=0&id=0dda078c&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dda078c"]])

export default __exports__